// extracted by mini-css-extract-plugin
module.exports = {"page_loader":"page-loader_page_loader__jOiCi","inner_page":"page-loader_inner_page__aSMNG","loader":"page-loader_loader__qTEAo","l14":"page-loader_l14__E_kJD"};